import type { ITypeStatistics } from "../../../types/meta"
import type { IPokemonsStatisticV2 } from "../../../types/models/pokemons-statistic-v2"
import { getServerUrl } from "../pages/utils/fetchConfigClient"
import { getAuth } from "../pages/utils/gitee-auth"

export type {
  IHistoryEntry,
  IPokemonStatV2,
  IPokemonsStatisticV2
} from "../../../types/models/pokemons-statistic-v2"

export async function fetchMetaPokemons(): Promise<IPokemonsStatisticV2[]> {
  return fetch(
    getServerUrl(`/meta/pokemons?t=${new Date().getUTCDate()}`)
  ).then((res) => res.json())
}

export async function fetchMetaTypes(): Promise<ITypeStatistics> {
  const token = await getAuth().then((user) => user?.idToken)
  return fetch(getServerUrl(`/meta/types?t=${new Date().getUTCDate()}`), {
    headers: {
      Authorization: `Bearer ${token}`
    }
  }).then((res) => res.json())
}
